/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Music_Notes_DoubleInputs */



/**
* | output |
* | --- |
* | "Double (♪♪)" |
*
* @param {Music_Notes_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const music_notes_double = /** @type {((inputs?: Music_Notes_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Music_Notes_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Double (♪♪)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Doppel (♪♪)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Doppio (♪♪)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Двойной (♪♪)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Doble (♪♪)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("双 (♪♪)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ダブル（♪♪）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डबल (♪♪)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duplo (♪♪)")
	return /** @type {LocalizedString} */ ("Double (♪♪)")
});